module.exports = __webpack_public_path__ + "img/password.f0e3860a.svg";